//react
import React, { Component } from 'react';

//data
import dataSiteMap from '../../siteMap.json';

class ContactUs extends Component {
	componentDidMount() {
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}

	render() {
		const culture = this.props.culture;

		switch (culture) {
			case 'at':
				return (
					<div className="content-page__content">
						<h1>Kontaktiere uns</h1>
	               <p>Mundipharma Gesellschaft m.b.H.</p>
                   <p><a href="mailto:Medinfo-DACH-CEE@mundipharma.de">Medinfo-DACH-CEE@mundipharma.de</a>
                </p>
                </div>
                );
			case 'dk':
				return (
					<div className="content-page__content">
						<h1>Kontakt os</h1>
						<p>Mundipharma A/S</p>
                   <p>E-mail: <a href="mailto:nordics@mundipharma.dk">nordics@mundipharma.dk</a>
						</p>
					</div>
				);
			case 'ie':
				return (
					<div className="content-page__content">
						<h1>Contact us</h1>
                    	<p>Mundipharma Pharmaceuticals Limited</p>
                    <p>Email: <a href="mainto:enquiries@napp.co.uk">enquiries@napp.co.uk</a>
                    </p>
					</div>
				);
			case 'it':
				return (
					<div className="content-page__content">
						<h1>Contatti</h1>
					<p>
					Mundipharma Pharmaceuticals Srl</p>
                    <p><a href="mailto:info@mundipharma.it">info@mundipharma.it</a>
								</p>
					</div>
				);
			case 'no':
				return (
					<div className="content-page__content">
						<h1>Kontakt oss</h1>
						<p>Mundipharma AS</p>
                    <p>E-post: <a href="mailto:nordics@mundipharma.dk">nordics@mundipharma.dk</a>
						</p>
					</div>
				);
			case 'se':
				return (
					<div className="content-page__content">
						<h1>Kontakta oss</h1>
						<p>Mundipharma AB</p>
                    <p>E-mail: <a href="mailto:nordics@mundipharma.dk">nordics@mundipharma.dk</a>
						</p>
					</div>
				);
			case 'uk':
				return (
					<div className="content-page__content">
						<h1>Contact us</h1>
						<p>Mundipharma Pharmaceuticals Limited</p>
                    <p>Email: <a href="mainto:enquiries@napp.co.uk">enquiries@napp.co.uk</a>
                    </p>
					</div>
				);
			case 'cz':
				return (
					<div className="content-page__content">
						<h1>Kontakty</h1>
						<p> 
                    Mundipharma Gesellschaft m.b.H.,<br />organizační složka</p>
                   <p>Email: <a href="mailto:Medinfo-DACH-CEE@mundipharma.de">Medinfo-DACH-CEE@mundipharma.de</a>
						</p>
					</div>
				);
        case 'de':
				return (
					<div className="content-page__content">
						<h1>Kontaktiere uns</h1>
						<p>Mundipharma GmbH<br />
                    Gebührenfreie</p>
                    <p>Email: <a href="mailto:Medinfo-DACH-CEE@mundipharma.de">Medinfo-DACH-CEE@mundipharma.de</a>
						</p>
					</div>
				);
       case 'lu':
				return (
					<div className="content-page__content">
						<h1>Kontaktiere uns</h1>
						<p>Mundipharma BV</p>
                        <p>Email: <a href="mailto:Medinfo-DACH-CEE@mundipharma.de">Medinfo-DACH-CEE@mundipharma.de</a>
						</p>
					</div>
				);
                
        case 'lu-fr':
				return (
					<div className="content-page__content">
						<h1>Contactez-nous</h1>
						<p>Mundipharma BV</p>
                    <p>Email: <a href="mailto:qualité@mundipharma.fr">qualité@mundipharma.fr</a>
                    </p>
					</div>
				);
        case 'lv':
                return (
					<div className="content-page__content">
						<h1>Sazinies ar mums</h1>
                    <p> SIA Inovatīvo biomedicīnas tehnoloģiju institūts</p>
                    <p>E-pasts: <a href="mailto:Medinfo-DACH-CEE@mundipharma.de">Medinfo-DACH-CEE@mundipharma.de</a> 
                    </p>
					</div>
				);
       case 'ee':
				return (
					<div className="content-page__content">
						<h1>Võta meiega ühendust</h1>
						<p>Mundipharma Corporation (Ireland) Limited<br />
                        L-Irlanda</p>
                       <p>E-mail: <a href="mailto:Medical-Operations@mundipharma.com">Medical-Operations@mundipharma.com</a></p>
					</div>
				); 
     case 'hr':
				return (
					<div className="content-page__content">
						<h1>Kontaktirajte nas</h1>
						<p>Medis Adria d.o.o.</p>
                   <p>E-mail: <a href="mailto:Medical-Operations@mundipharma.com">Medical-Operations@mundipharma.com</a>
						</p>
					</div>
				);  
        case 'pl':
				return (
					<div className="content-page__content">
						<h1>Skontaktuj się z nami</h1>
						<p>Mundipharma Polska Sp. z o.o.</p>
                    <p>E-mail: <a href="mailto:Medinfo-DACH-CEE@mundipharma.de">Medinfo-DACH-CEE@mundipharma.de</a>.
						</p>
					</div>
				);      
                
   			default: //global
				return (
					<div className="content-page__content">
						<h1>Contact us</h1>
						{dataSiteMap.uk.live &&
							<div className="content-page__content__optional">
								<h2>Contact us</h2>
                    <p>
                    E-mail: <a href="mailto:medical-operations@mundipharma.com">medical-operations@mundipharma.com</a>.
						</p>		
                    		</div>
						}
					</div>
				);
		}
	}
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/content/legal/contactUs.js